import { styled } from '@mui/material';

export const Container = styled('div')();

export const ContentContainer = styled('div')();

export const ButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(1),
}));
